module.exports = __webpack_public_path__ + "media/prk/assets/images/icons/standard-a4fec3082735dbaaa98432c17faf7da2.svg";